/**
 * Shared vanity-config read (shell-bootstrap): one memoised GET served to
 * every caller that needs the runtime vanity mapping, so a cold load pays for
 * it once no matter how many modules ask.
 *
 * Import-free leaf on purpose: apiClient and authConfig both use it, and
 * importing either of them here would re-create the import cycle authConfig
 * documents. Read the baked app config straight off the window like they do.
 */

const config = window.__APP_CONFIG__ || __APP_CONFIG__

let cachedRequest = null

/**
 * GET /api/vanity-config, memoised for the session. Pass { fresh: true } for
 * an explicit refresh (vanity hostname created, refreshed or deleted).
 * A failed read never pins the session: the cache clears so the next read
 * retries.
 */
export function requestVanityConfig({ fresh = false } = {}) {
  if (!fresh && cachedRequest) return cachedRequest
  const request = fetch(`${config.apiUrl}/api/vanity-config`)
    .then(async (res) => {
      if (!res.ok) throw new Error(`vanity-config responded ${res.status}`)
      return res.json()
    })
    .catch((error) => {
      if (cachedRequest === request) cachedRequest = null
      throw error
    })
  cachedRequest = request
  return request
}
